@if (!!item) {
<svg height="100%" width="100%" viewBox="-24.7 8 249.4 304"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <clipPath [attr.id]="'bk-clip-' + item.id">
      <rect x="56" y="98" width="88" height="190"/>
    </clipPath>
  </defs>

  <!-- Wire bail handle (behind the lid) -->
  <path d="M52 90 C62 40 138 40 148 90" fill="none" stroke="#9aa0a8" stroke-width="3" stroke-linecap="round"/>

  <!-- Liquid fill (clipped to the near-vertical body) -->
  <rect [attr.clip-path]="'url(#bk-clip-' + item.id + ')'" x="56" [attr.y]="y" [attr.height]="height" width="88" [attr.fill]="item.color || item.beverage?.color || '#d99a2b'"/>

  <!-- Translucent plastic body: wide, vertical walls -->
  <rect x="54" y="96" width="92" height="194" fill="#f2f2ec" fill-opacity="0.34" stroke="#0f0f0f" stroke-width="1.5" stroke-linejoin="round"/>

  <!-- Volume graduation ticks -->
  <g stroke="#b9b9b0" stroke-width="1">
    <line x1="137" y1="130" x2="144" y2="130"/>
    <line x1="137" y1="170" x2="144" y2="170"/>
    <line x1="137" y1="210" x2="144" y2="210"/>
    <line x1="137" y1="250" x2="144" y2="250"/>
  </g>

  <!-- Lid with overhanging rim lip -->
  <rect x="50" y="88" width="100" height="9" rx="3" fill="#e9e9e2" stroke="#b9b9b0" stroke-width="1.5"/>
  <rect x="54" y="78" width="92" height="11" rx="4" fill="#f5f5ef" stroke="#b9b9b0" stroke-width="1.5"/>

  <!-- 3-piece airlock (offset so the bail clears it) -->
  <rect x="116" y="64" width="5" height="15" fill="#cfe0ea" stroke="#8fb6cc"/>
  <ellipse cx="118.5" cy="59" rx="6" ry="7" fill="#cfe0ea" stroke="#8fb6cc"/>
  <rect x="116" y="52" width="5" height="4" fill="#8fb6cc"/>

  <!-- Bottom spigot / tap -->
  <rect x="46" y="258" width="13" height="7" rx="2" fill="#c9ced6" stroke="#7f8790"/>
  <rect x="49" y="252" width="6" height="6" rx="1" fill="#e23b3b"/>

  <!-- Silhouette -->
  <rect x="54" y="96" width="92" height="194" fill="none" stroke="#9aa096" stroke-width="1.2" stroke-linejoin="round" opacity="0.6"/>
</svg>
}
